@if (isInitialized) {
  <oe-modal [title]="component?.alias || componentId" [component]="component" [formGroup]="costRevenueFormGroup"
            helpKey="CONTROLLER_ENERGY_COST_REVENUE">

    <oe-modal-line
      [name]="'EDGE.INDEX.WIDGETS.COST_REVENUE.DAILY_TOTAL_COST' | translate"
      [channelAddress]="componentId + '/DailyActualTotalCost'"
      [converter]="eurConverter">
    </oe-modal-line>

    <oe-modal-line
      [name]="'EDGE.INDEX.WIDGETS.COST_REVENUE.DAILY_SAVINGS' | translate"
      [channelAddress]="componentId + '/DailyCashflowSavingsVsAllFromGrid'"
      [converter]="eurConverter">
    </oe-modal-line>

    <oe-modal-line
      [name]="'EDGE.INDEX.WIDGETS.COST_REVENUE.MODAL.DAILY_ALL_FROM_GRID_COST' | translate"
      [channelAddress]="componentId + '/DailyAllFromGridCost'"
      [converter]="eurConverter">
    </oe-modal-line>

    <oe-modal-line
      [name]="'EDGE.INDEX.WIDGETS.COST_REVENUE.MODAL.DAILY_FULL_COST_SAVINGS' | translate"
      [channelAddress]="componentId + '/DailySavingsVsAllFromGrid'"
      [converter]="eurConverter">
    </oe-modal-line>

    <oe-modal-horizontal-line></oe-modal-horizontal-line>
    <oe-modal-info-line [info]="'EDGE.INDEX.WIDGETS.COST_REVENUE.MODAL.TODAY_ENERGY' | translate"></oe-modal-info-line>

    <oe-modal-line
      [name]="'EDGE.INDEX.WIDGETS.COST_REVENUE.MODAL.GRID_BUY_ENERGY' | translate"
      [channelAddress]="componentId + '/DailyGridBuyEnergyWh'"
      [converter]="energyKwhConverter">
    </oe-modal-line>

    <oe-modal-line
      [name]="'EDGE.INDEX.WIDGETS.COST_REVENUE.MODAL.GRID_SELL_ENERGY' | translate"
      [channelAddress]="componentId + '/DailyGridSellEnergyWh'"
      [converter]="energyKwhConverter">
    </oe-modal-line>

    <oe-modal-line
      [name]="'EDGE.INDEX.WIDGETS.COST_REVENUE.MODAL.PRODUCTION_ENERGY' | translate"
      [channelAddress]="componentId + '/DailyProductionEnergyWh'"
      [converter]="energyKwhConverter">
    </oe-modal-line>

    <oe-modal-line
      [name]="'EDGE.INDEX.WIDGETS.COST_REVENUE.MODAL.CONSUMPTION_ENERGY' | translate"
      [channelAddress]="componentId + '/DailyConsumptionEnergyWh'"
      [converter]="energyKwhConverter">
    </oe-modal-line>

    <oe-modal-line
      [name]="'EDGE.INDEX.WIDGETS.COST_REVENUE.MODAL.SELF_SUPPLIED_ENERGY' | translate"
      [channelAddress]="componentId + '/DailySelfSuppliedEnergyWh'"
      [converter]="energyKwhConverter">
    </oe-modal-line>

    <oe-modal-line
      [name]="'EDGE.INDEX.WIDGETS.COST_REVENUE.MODAL.ESS_DISCHARGE_ENERGY' | translate"
      [channelAddress]="componentId + '/DailyEssDischargeEnergyWh'"
      [converter]="energyKwhConverter">
    </oe-modal-line>

    <oe-modal-horizontal-line></oe-modal-horizontal-line>
    <oe-modal-info-line [info]="'EDGE.INDEX.WIDGETS.COST_REVENUE.MODAL.CONFIGURATION' | translate"></oe-modal-info-line>

    <oe-modal-line
      [name]="('EDGE.INDEX.WIDGETS.COST_REVENUE.MODAL.PV_COST' | translate) + ' [€/kWh]'"
      [formGroup]="costRevenueFormGroup" controlName="pvCostEurPerKwh"
      [control]="{ type: 'INPUT' }"
      leftColumnWidth="60">
    </oe-modal-line>

    <oe-modal-line
      [name]="('EDGE.INDEX.WIDGETS.COST_REVENUE.MODAL.ESS_COST' | translate) + ' [€/kWh]'"
      [formGroup]="costRevenueFormGroup" controlName="essCostEurPerKwh"
      [control]="{ type: 'INPUT' }"
      leftColumnWidth="60">
    </oe-modal-line>

    <oe-modal-horizontal-line></oe-modal-horizontal-line>
    <oe-modal-info-line [info]="'EDGE.INDEX.WIDGETS.COST_REVENUE.MODAL.TODAY_COSTS' | translate"></oe-modal-info-line>

    <oe-modal-line
      [name]="'EDGE.INDEX.WIDGETS.COST_REVENUE.MODAL.GRID_BUY_COST' | translate"
      [channelAddress]="componentId + '/DailyGridBuyCost'"
      [converter]="eurConverter">
    </oe-modal-line>

    <oe-modal-line
      [name]="'EDGE.INDEX.WIDGETS.COST_REVENUE.MODAL.GRID_SELL_REVENUE' | translate"
      [channelAddress]="componentId + '/DailyGridSellRevenue'"
      [converter]="eurConverter">
    </oe-modal-line>

    <oe-modal-line
      [name]="'EDGE.INDEX.WIDGETS.COST_REVENUE.MODAL.GRID_SELL_COST' | translate"
      [channelAddress]="componentId + '/DailyGridSellCost'"
      [converter]="eurConverter">
    </oe-modal-line>

    <oe-modal-line
      [name]="'EDGE.INDEX.WIDGETS.COST_REVENUE.MODAL.ACTUAL_GRID_ONLY_NET_COST' | translate"
      [channelAddress]="componentId + '/DailyActualGridOnlyNetCost'"
      [converter]="eurConverter">
    </oe-modal-line>

    <oe-modal-line
      [name]="'EDGE.INDEX.WIDGETS.COST_REVENUE.MODAL.CASHFLOW_SAVINGS' | translate"
      [channelAddress]="componentId + '/DailyCashflowSavingsVsAllFromGrid'"
      [converter]="eurConverter">
    </oe-modal-line>

    <oe-modal-line
      [name]="'EDGE.INDEX.WIDGETS.COST_REVENUE.MODAL.PV_ENERGY_COST' | translate"
      [channelAddress]="componentId + '/DailyPvEnergyCost'"
      [converter]="eurConverter">
    </oe-modal-line>

    <oe-modal-line
      [name]="'EDGE.INDEX.WIDGETS.COST_REVENUE.MODAL.ESS_DISCHARGE_COST' | translate"
      [channelAddress]="componentId + '/DailyEssDischargeCost'"
      [converter]="eurConverter">
    </oe-modal-line>

    <oe-modal-horizontal-line></oe-modal-horizontal-line>
    <oe-modal-info-line [info]="'EDGE.INDEX.WIDGETS.COST_REVENUE.MODAL.TOTAL' | translate"></oe-modal-info-line>

    <oe-modal-line
      [name]="'EDGE.INDEX.WIDGETS.COST_REVENUE.MODAL.TOTAL_ACTUAL_TOTAL_COST' | translate"
      [channelAddress]="componentId + '/TotalActualTotalCost'"
      [converter]="eurConverter">
    </oe-modal-line>

    <oe-modal-line
      [name]="'EDGE.INDEX.WIDGETS.COST_REVENUE.MODAL.TOTAL_ALL_FROM_GRID_COST' | translate"
      [channelAddress]="componentId + '/TotalAllFromGridCost'"
      [converter]="eurConverter">
    </oe-modal-line>

    <oe-modal-line
      [name]="'EDGE.INDEX.WIDGETS.COST_REVENUE.MODAL.TOTAL_CASHFLOW_SAVINGS' | translate"
      [channelAddress]="componentId + '/TotalCashflowSavingsVsAllFromGrid'"
      [converter]="eurConverter">
    </oe-modal-line>

    <oe-modal-line
      [name]="'EDGE.INDEX.WIDGETS.COST_REVENUE.MODAL.TOTAL_SAVINGS' | translate"
      [channelAddress]="componentId + '/TotalSavingsVsAllFromGrid'"
      [converter]="eurConverter">
    </oe-modal-line>


    <oe-modal-horizontal-line></oe-modal-horizontal-line>
    <oe-modal-info-line [info]="'EDGE.INDEX.WIDGETS.COST_REVENUE.MODAL.DESCRIPTION_TITLE' | translate"></oe-modal-info-line>
    <oe-modal-info-line [info]="'EDGE.INDEX.WIDGETS.COST_REVENUE.MODAL.DESCRIPTION_TOTAL_COST' | translate"
                        style="font-size: small;"></oe-modal-info-line>
    <oe-modal-info-line [info]="'EDGE.INDEX.WIDGETS.COST_REVENUE.MODAL.DESCRIPTION_CASHFLOW_SAVINGS' | translate"
                        style="font-size: small;"></oe-modal-info-line>
    <oe-modal-info-line [info]="'EDGE.INDEX.WIDGETS.COST_REVENUE.MODAL.DESCRIPTION_FULL_COST_ADVANTAGE' | translate"
                        style="font-size: small;"></oe-modal-info-line>
    <oe-modal-info-line [info]="'EDGE.INDEX.WIDGETS.COST_REVENUE.MODAL.DESCRIPTION_GRID_BUY_COST' | translate"
                        style="font-size: small;"></oe-modal-info-line>
    <oe-modal-info-line [info]="'EDGE.INDEX.WIDGETS.COST_REVENUE.MODAL.DESCRIPTION_FEED_IN' | translate"
                        style="font-size: small;"></oe-modal-info-line>
    <oe-modal-info-line [info]="'EDGE.INDEX.WIDGETS.COST_REVENUE.MODAL.DESCRIPTION_PV_ESS_COST' | translate"
                        style="font-size: small;"></oe-modal-info-line>
  </oe-modal>
}
